import React from 'react'

import { Button } from '@frame/ui-primitives/button'
import { Card } from '@frame/ui-primitives/card'
import { H4 } from '@frame/ui-primitives/h4'
import { P } from '@frame/ui-primitives/p'

import { DataAttribute } from '@frame/types'

type Props = {
  handleConnectBank: () => void
  isTenantVerifier?: boolean
}

export function ConnectBankCard({ handleConnectBank, isTenantVerifier }: Props) {
  return (
    <Card data-cy={DataAttribute.CONNECT_BANK_CARD} intent="primary" className="p-4">
      {isTenantVerifier ? (
        <>
          <H4 as="div">I have multiple sources of income</H4>
          <P variant="small" className="mt-2">
            Select this option if you are self-employed, a contractor, military, or a retiree.
          </P>
        </>
      ) : (
        <>
          <H4 as="div">Link your bank</H4>
          <P variant="small" className="mt-2">
            <strong>Fastest.</strong> Creates a secure and temporary connection for proof of income.
          </P>
        </>
      )}
      <Button applyCobranding onClick={handleConnectBank} className="mt-4">
        Connect bank accounts
      </Button>
    </Card>
  )
}
